import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { FILTER_INPUT_CLASS } from './filterStyles.js';

const MultiSelectDropdown = ({
  options = [],
  selected = [],
  onChange,
  placeholder = 'Select...',
  className = '',
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggle = (val) => {
    onChange(
      selected.includes(val)
        ? selected.filter((v) => v !== val)
        : [...selected, val]
    );
  };

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`${FILTER_INPUT_CLASS} text-left flex justify-between items-center gap-2`}
      >
        <span className={`truncate ${selected.length === 0 ? 'text-gray-400' : 'text-gray-800'}`}>
          {selected.length === 0 ? placeholder : `${selected.length} selected`}
        </span>
        <ChevronDown
          className={`w-4 h-4 text-gray-400 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-card shadow-medium max-h-52 overflow-y-auto">
          {options.map((opt) => {
            const value = opt.value ?? opt;
            const label = opt.label ?? opt;
            return (
              <label
                key={value}
                className="flex items-center gap-2 px-3 py-2.5 hover:bg-brand-light cursor-pointer text-sm"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(value)}
                  onChange={() => toggle(value)}
                  className="accent-brand rounded"
                />
                {label}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
